import React, { useEffect, useRef } from 'react';

const AdBanner = () => {
  const bannerRef = useRef(null);

  useEffect(() => {
    // Check karein ki element pehle se populated toh nahi hai
    if (bannerRef.current && !bannerRef.current.firstChild) {
      // 1. atOptions configuration script banayein
      const confScript = document.createElement('script');
      confScript.type = 'text/javascript';
      confScript.text = `
        atOptions = {
          'key' : '2adccb6ab13d54e1377934a7cc2b51ec',
          'format' : 'iframe',
          'height' : 60,
          'width' : 728,
          'params' : {}
        };
      `;

      // 2. Main ad external script banayein
      const adScript = document.createElement('script');
      adScript.type = 'text/javascript';
      adScript.src = 'https://bellnewyork.org/22/2adccb6ab13d54e1377934a7cc2b51ec';
      adScript.async = true;

      // 3. Dono scripts ko reference div ke andar append kar dein
      bannerRef.current.appendChild(confScript);
      bannerRef.current.appendChild(adScript);
    }
  }, []);

  return (
    <div className="ad-container" style={{ minHeight: '50px', textAlign: 'center' }}>
      {/* Yeh div ad ko hold karega */}
      <div ref={bannerRef} />
    </div>
  );
};

export default AdBanner;